/* eslint-disable react-hooks/exhaustive-deps */
import { FC, Key, useCallback } from 'react'
import type { TableColumnsType } from 'antd'
import { Table } from 'antd'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import { ExpandableRowData, Ticket } from '@types'

import { DATE_KEYS } from '../../constants/dateKeys'

interface ExpandableTableProps {
  columns: TableColumnsType<Ticket>
  handleSetRowData: (expandedKeys: readonly Key[]) => void
  expandedRows: readonly Key[]
  data?: ExpandableRowData[]
}

const ExpandableTable: FC<ExpandableTableProps> = ({
  columns,
  handleSetRowData,
  expandedRows,
  data,
}) => {
  const { t } = useTranslation()
  const expandedRowRender = useCallback(
    ({ tickets }: ExpandableRowData) => {
      return <Table columns={columns} dataSource={tickets} pagination={false} />
    },
    [data, columns],
  )

  const colapsedColumns: TableColumnsType<ExpandableRowData> = [
    {
      title: t('globals.generics.date'),
      dataIndex: 'key',
      key: 'key',
    },
  ]

  return (
    <Table
      showHeader={false}
      style={{ flex: 1 }}
      sortDirections={['ascend']}
      columns={colapsedColumns}
      rowClassName={(_record, index) =>
        `expandable-row ${index % 2 === 0 ? 'odd-row' : 'even-row'}`
      }
      expandable={{
        expandedRowRender,
        expandedRowKeys: expandedRows,
        onExpandedRowsChange: handleSetRowData,
        expandRowByClick: true,
      }}
      pagination={false}
      dataSource={data?.sort((a, b) =>
        dayjs(a.key, DATE_KEYS.FORMAT.DAY_SHORT).diff(
          dayjs(b.key, DATE_KEYS.FORMAT.DAY_SHORT),
          'day',
        ),
      )}
      size="middle"
    />
  )
}

export default ExpandableTable
